import o from "./index183.mjs";
import t from "./index184.mjs";
import a from "./index185.mjs";
import r from "./index186.mjs";
import e from "./index187.mjs";
var m = {
  code: "es",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const n = m;
export {
  n as default
};
//# sourceMappingURL=index163.mjs.map
